export const load = () => ({
	h1: 'Laser Measure Form',
	title: 'Understand And Download Our Laser Measure Form',
	description:
		'How to use the Laser Measure form to get accurate results for your Indow inserts.',
	showTitle: false,
});
